/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Source_YoutubeInputs */

const en_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const fr_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const de_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const it_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const ru_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const es_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const zh_cn2_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

const ja_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーチューブ`)
};

const hi_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यूट्यूब`)
};

const pt_pt2_media_import_source_youtube = /** @type {(inputs: Media_Import_Source_YoutubeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube`)
};

/**
* | output |
* | --- |
* | "YouTube" |
*
* @param {Media_Import_Source_YoutubeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_source_youtube = /** @type {((inputs?: Media_Import_Source_YoutubeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Source_YoutubeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_import_source_youtube(inputs)
	if (locale === "de") return de_media_import_source_youtube(inputs)
	if (locale === "it") return it_media_import_source_youtube(inputs)
	if (locale === "ru") return ru_media_import_source_youtube(inputs)
	if (locale === "es") return es_media_import_source_youtube(inputs)
	if (locale === "zh-CN") return zh_cn2_media_import_source_youtube(inputs)
	if (locale === "ja") return ja_media_import_source_youtube(inputs)
	if (locale === "hi") return hi_media_import_source_youtube(inputs)
	if (locale === "pt-PT") return pt_pt2_media_import_source_youtube(inputs)
	return en_media_import_source_youtube(inputs)
});